import { useSearchParams } from "react-router";
import {
  parseSelectedSitesFromSearch,
  replaceSelectedSitesInParams,
} from "./selectedSitesHelper";

/**
 * Selected sites represented by the current URL query string.
 */
export function useSelectedSites() {
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedSites = parseSelectedSitesFromSearch(searchParams.toString());

  const setSelected = (sites: string[]) => {
    setSearchParams((params) => replaceSelectedSitesInParams(params, sites), {
      replace: true,
    });
  };

  const toggleSelected = (siteName: string) => {
    const sites = selectedSites.includes(siteName)
      ? selectedSites.filter((site) => site !== siteName)
      : [...selectedSites, siteName];
    setSelected(sites);
  };

  const clearSelected = () => setSelected([]);

  return {
    selectedSite: selectedSites.length > 0 ? selectedSites[0] : undefined,
    selectedSites,
    isMultiSiteMode: selectedSites.length > 1,
    setSelected,
    toggleSelected,
    clearSelected,
  };
}
